module.exports = __webpack_public_path__ + "static/media/cq_documento.faeaeef4.svg";